__turbopack_context__.v({
  "backLink": "wtiXha_backLink",
  "content": "wtiXha_content",
  "description": "wtiXha_description",
  "duration": "wtiXha_duration",
  "meta": "wtiXha_meta",
  "metaRow": "wtiXha_metaRow",
  "page": "wtiXha_page",
  "title": "wtiXha_title",
  "topic": "wtiXha_topic",
  "youtubeLink": "wtiXha_youtubeLink",
});
